import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05f9bd63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rule-manage-box" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "msg-box"
}
const _hoisted_4 = {
  key: 1,
  class: "msg-box"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "谈判", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "已注册", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "无合作可能", -1))
const _hoisted_8 = {
  key: 2,
  class: "msg-box"
}
const _hoisted_9 = {
  key: 3,
  class: "msg-box"
}
const _hoisted_10 = {
  key: 4,
  class: "msg-box"
}
const _hoisted_11 = { class: "subTitle" }
const _hoisted_12 = {
  key: 5,
  class: "msg-box"
}
const _hoisted_13 = {
  key: 0,
  class: "footer-box"
}
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_DayOffCalendar = _resolveComponent("DayOffCalendar")!
  const _component_CosFixFooterPage = _resolveComponent("CosFixFooterPage")!

  return (_openBlock(), _createBlock(_component_CosFixFooterPage, {
    autoFooter: _ctx.selectData.target !== 'dayOffSetting'
  }, {
    footer: _withCtx(() => [
      (_ctx.selectData.target !== 'dayOffSetting')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.handleSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.selectData.title), 1),
        (_ctx.selectData.target === 'saleCue')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", null, [
                _createTextVNode(" 每个用户，每天最多领取"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_1[0],
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_1[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("条销售线索 ")
              ]),
              _createElementVNode("p", null, [
                _createTextVNode(" 线索领取后，"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_2[0],
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_2[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日内未填写"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_2[1],
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_2[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("条跟进记录，系统自动将线索退回到公共线索池，并且同一销售无法对该线索进行二次认领； 线索退回到公共线索池前"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_2[2],
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_2[2]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日通过飞书提醒客户负责人； ")
              ]),
              _createElementVNode("p", null, [
                _createTextVNode("置为【未来线索】后，"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_4[0],
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_4[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("天后未变为跟进中，则自动进入公海池；")
              ]),
              _createElementVNode("p", null, [
                _createTextVNode("置为【无效线索】后，"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_5[0],
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_5[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("天后未变为跟进中，则自动进入公海池。")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectData.target === 'potentialCustomer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", null, [
                _createTextVNode(" 状态潜在客户,在距离最后一次跟进记录"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.POTENTIAL_RULE_1[0],
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.saleFormState.POTENTIAL_RULE_1[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日后还没有再次跟进，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。 ")
              ]),
              _hoisted_6,
              _createElementVNode("p", null, [
                _createTextVNode(" 状态潜在客户,在距离最后一次跟进记录"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.POTENTIAL_RULE_2[0],
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.saleFormState.POTENTIAL_RULE_2[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日后还没有再次跟进，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。 ")
              ]),
              _hoisted_7,
              _createElementVNode("p", null, [
                _createTextVNode(" 状态潜在客户,在距离最后一次跟进记录"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.POTENTIAL_RULE_3[0],
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.saleFormState.POTENTIAL_RULE_3[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日后还没有再次跟进，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。 ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectData.target === 'successCustomer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("p", null, [
                _createTextVNode(" 除【流失】状态外，在距离最后一次跟进记录"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.DEAL_RULE_1[0],
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.saleFormState.DEAL_RULE_1[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日后还没有再次跟进，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。 ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectData.target === 'appSignSetting')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("p", null, [
                _createTextVNode(" 签到列表，展示自身定位"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.SIGN_IN_RULE_1[0],
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.saleFormState.SIGN_IN_RULE_1[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("米范围内的客户信息。（仅能在范围内签到） ")
              ]),
              _createElementVNode("p", null, [
                _createTextVNode(" 签到打卡后，在上次签到范围内"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.SIGN_IN_RULE_2[0],
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.saleFormState.SIGN_IN_RULE_2[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("分钟后才能第二次打卡签到；同一个客户"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.SIGN_IN_RULE_2[1],
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.saleFormState.SIGN_IN_RULE_2[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("分钟后才能第二次打卡签到。 ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectData.target === 'businessSetting')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessSettingList, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.key
                }, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.label), 1),
                  _createElementVNode("p", null, [
                    _createTextVNode(" 在商机距离最后一次变更状态"),
                    _createVNode(_component_a_input_number, {
                      class: "input",
                      precision: 0,
                      min: 1,
                      value: _ctx.saleFormState[item.key][0],
                      "onUpdate:value": ($event: any) => ((_ctx.saleFormState[item.key][0]) = $event),
                      placeholder: "请输入"
                    }, null, 8, ["value", "onUpdate:value"]),
                    _createTextVNode("个工作日后还没有再次变更其他状态，通过第三方（飞书）、系统弹窗提醒商机负责人跟进，超时仍未跟进标记【超时】。 ")
                  ])
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectData.target === 'clueCreateSetting')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("p", null, [
                _createTextVNode(" 线索自动创建后默认的线索负责人 "),
                _createVNode(_component_UserSelect, {
                  value: _ctx.saleFormState.CLUE_DEFAULT_EMPLOYEE,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.saleFormState.CLUE_DEFAULT_EMPLOYEE) = $event)),
                  style: {"width":"250px"},
                  placeholder: "请选择客户负责人",
                  allowClear: ""
                }, null, 8, ["value"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.selectData.target === 'dayOffSetting')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_DayOffCalendar, { typePage: 'cos_lbu' })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["autoFooter"]))
}